import { EnvironmentConfig } from './environment.types';

export const productionConfig: EnvironmentConfig = {
  API_URL: process.env.REACT_APP_API_URL || 'https://api-dev-v3.aigp.health/api/v1/ehr',
  AUTH_URL: process.env.REACT_APP_AUTH_URL || 'https://auth-dev-v3.aigp.health',
  LOGIN_URL: process.env.REACT_APP_LOGIN_URL || 'https://api-dev-v3.aigp.health/api/v1/ehr',
  LOCAL_RELAY_SERVER_URL: process.env.REACT_APP_LOCAL_RELAY_SERVER_URL || '',
  ENV: 'production',
  CLIENT_ID: process.env.REACT_APP_CLIENT_ID || '',
};